import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  templateItem: {
    paddingTop: 12,
    paddingBottom: 12,
    textAlign: 'center',
    backgroundColor: theme.palette.grey[200],
    borderRadius: 12,
    cursor: 'pointer',
    transition: 'all 0.25s linear',
    position: 'relative',
    height: 'fit-content',
    marginBottom: 6
  },
  disabled: { opacity: '50%' },
  activeTemplateItem: {
    backgroundColor: theme.palette.grey[100],
    border: `2px solid ${theme.palette.primary.main}`
  },
  activeCircle: {
    position: 'absolute',
    right: 10,
    width: 12,
    height: 12,
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main
  }
}))
